export const STAYS_ENDPOINTS = {
  home: "/api/Stay/GetHome",
  search: "/api/Stay/Search",
  hotels: "/api/Stay/GetHotels",
  hotelById: "/api/Stay/GetHotelById",
  brands: "/api/Stay/GetBrands",
  cities: "/api/Stay/GetCities",
};
